<button mat-button [matMenuTriggerFor]="belowMenu">
	<svg focusable="false" aria-hidden="true" class="w-[2rem] h-[2rem]">
		<use [attr.xlink:href]="'#icon-language'"></use>
	</svg>
</button>
<mat-menu #belowMenu="matMenu" yPosition="below">
	<button mat-menu-item (click)="setCurrentLanguage('en')">
		<a
			class="cursor-pointer text-base transition-all flex items-center gap-2 text-black md:hover:text-textYellow md:p-0 md:hover:text-text-textYellow"
			[ngClass]="{
				'text-textYellow': translateService.currentLang === 'en',
				'text-fontColor': translateService.currentLang === 'ar'
			}"
		>
			<svg focusable="false" aria-hidden="true" class="w-[1rem] h-[1rem]">
				<use [attr.xlink:href]="'#icon-english'"></use>
			</svg>
			{{ "header.languages.en" | translate }}</a
		>
	</button>
	<button mat-menu-item (click)="setCurrentLanguage('ar')">
		<a
			class="cursor-pointer text-base transition-all flex items-center gap-2 text-black mover:text-textYellow hover:text-text-textYellow"
			[ngClass]="{
				'text-textYellow': translateService.currentLang === 'ar',
				'text-fontColor': translateService.currentLang === 'en'
			}"
		>
			<svg focusable="false" aria-hidden="true" class="w-[1rem] h-[1rem]">
				<use [attr.xlink:href]="'#icon-arabic'"></use>
			</svg>
			{{ "header.languages.ar" | translate }}</a
		>
	</button>
</mat-menu>
<svg style="display: none" xmlns="http://www.w3.org/2000/svg">
	<!-- Egypt Flag  -->
	<symbol id="icon-arabic" viewBox="0 0 32 32">
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M29.603 5.517h-27.207c-1.324 0-2.397 1.073-2.397 2.397v4.592h32v-4.592c0-1.324-1.073-2.397-2.397-2.397z"
		></path>
		<path
			fill="#464655"
			style="fill: var(--color2, #464655)"
			d="M0 24.086c0 1.324 1.073 2.397 2.397 2.397h27.207c1.324 0 2.397-1.073 2.397-2.397v-4.592h-32v4.592z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M0 12.506h32v6.988h-32v-6.988z"
		></path>
		<path
			fill="#f0c727"
			style="fill: var(--color4, #f0c727)"
			d="M17.762 14.911c0-0.274-0.268-0.467-0.528-0.38l-0.488 0.163-0.118-0.715c-0.071-0.427-0.436-0.736-0.869-0.736h-0.456l-0.477 0.587h0.632l-0.177 0.873-0.515-0.171c-0.26-0.087-0.528 0.107-0.528 0.38v2.967l0.71-0.71-0.335 1.004h-0.376v0.587h3.523v-0.587h-0.375l-0.335-1.004 0.71 0.71v-2.967h-0zM15.706 18.171h-0.473l0.325-0.869 0.148 0.189v0.68zM16.294 18.171v-0.68l0.148-0.189 0.326 0.869h-0.473zM16 17.107c0 0-0.908-0.615-0.872-1.762 0 0 0.56-0.092 0.872-0.587 0.312 0.495 0.872 0.587 0.872 0.587 0.037 1.147-0.872 1.762-0.872 1.762z"
		></path>
	</symbol>

	<!-- America Flag  -->
	<symbol id="icon-english" viewBox="0 0 32 32">
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M29.603 5.517h-27.207c-1.324 0-2.397 1.073-2.397 2.397v16.172c0 1.324 1.073 2.397 2.397 2.397h27.207c1.324 0 2.397-1.073 2.397-2.397v-16.172c0-1.324-1.073-2.397-2.397-2.397z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0.132 7.13h31.736c-0.325-0.939-1.216-1.613-2.265-1.613h-27.207c-1.049 0-1.94 0.674-2.265 1.613z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0 11.968h32v1.613h-32v-1.613z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0 8.742h32v1.613h-32v-1.613z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0 16.255c0 0.305 0.247 0.552 0.552 0.552h31.448v-1.613h-32v1.061z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0 21.645h32v1.613h-32v-1.613z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M31.868 24.87h-31.736c0.325 0.939 1.216 1.613 2.265 1.613h27.207c1.049 0 1.94-0.674 2.265-1.613z"
		></path>
		<path
			fill="#ff4b55"
			style="fill: var(--color1, #ff4b55)"
			d="M0 18.419h32v1.613h-32v-1.613z"
		></path>
		<path
			fill="#41479b"
			style="fill: var(--color5, #41479b)"
			d="M0.552 16.806h13.793c0.305 0 0.552-0.247 0.552-0.552v-10.186c0-0.305-0.247-0.552-0.552-0.552h-11.948c-1.324 0-2.397 1.073-2.397 2.397v8.341c0 0.305 0.247 0.552 0.552 0.552z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M1.549 6.784l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.224c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.048 0.083-0.048 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M1.549 8.699l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M1.549 10.615l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M1.549 12.531l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M1.549 14.447l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M3.036 7.723l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.116 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.116-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M3.036 9.639l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.116 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.116-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M3.036 11.555l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.116 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.116-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M3.036 13.471l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.116 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.116-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M4.523 6.784l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.224c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M4.523 8.699l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M4.523 10.615l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M4.523 12.531l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M4.523 14.447l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M6.011 7.723l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M6.011 9.639l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M6.011 11.555l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M6.011 13.471l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M7.498 6.784l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.224c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.048 0.083-0.048 0.099-0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M7.498 8.699l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M7.498 10.615l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M7.498 12.531l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M7.498 14.447l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.019-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M8.985 7.723l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M8.985 9.639l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M8.985 11.555l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M8.985 13.471l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M10.472 6.784l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.224c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M10.472 8.699l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M10.472 10.615l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M10.472 12.531l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M10.472 14.447l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M11.959 7.723l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M11.959 9.639l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M11.959 11.555l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M11.959 13.471l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M13.446 6.784l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.224-0.314 0.224c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M13.446 8.699l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M13.446 10.615l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M13.446 12.531l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
		<path
			fill="#f5f5f5"
			style="fill: var(--color3, #f5f5f5)"
			d="M13.446 14.447l0.122 0.366 0.386 0.003c0.050 0 0.071 0.064 0.030 0.094l-0.311 0.229 0.117 0.368c0.015 0.048-0.039 0.087-0.080 0.058l-0.314-0.225-0.314 0.225c-0.041 0.029-0.095-0.010-0.080-0.058l0.117-0.368-0.311-0.229c-0.040-0.030-0.020-0.093 0.030-0.094l0.386-0.003 0.122-0.366c0.016-0.047 0.083-0.047 0.099 0z"
		></path>
	</symbol>

	<symbol id="icon-language" viewBox="0 0 32 32">
		<path
			fill="#51749b"
			style="fill: var(--color1, #51749b)"
			d="M25.173 31.147h-17.6c-3.2 0-5.867-2.56-5.867-5.867v-18.56c0-3.2 2.56-5.867 5.867-5.867h17.6c3.2 0 5.867 2.56 5.867 5.867v18.56c0 3.2-2.667 5.867-5.867 5.867z"
		></path>
		<path
			fill="#113149"
			style="fill: var(--color2, #113149)"
			d="M16 6.653c-5.44 0-9.92 4.48-9.92 9.92s4.48 9.92 9.92 9.92 9.92-4.48 9.92-9.92-4.48-9.92-9.92-9.92zM16 8.253c0.107 0 0.32 0.107 0.64 0.427s0.64 0.96 0.853 1.707c0.213 0.533 0.32 1.173 0.427 1.813-0.64 0.107-1.28 0.213-2.027 0.213s-1.387-0.107-2.027-0.213c0.107-0.64 0.32-1.28 0.427-1.813 0.32-0.747 0.64-1.387 0.853-1.707 0.533-0.32 0.747-0.427 0.853-0.427zM18.667 8.68c1.067 0.32 2.027 0.853 2.773 1.6-0.213 0.427-0.533 0.853-1.28 1.173-0.107 0.107-0.32 0.107-0.427 0.213-0.107-0.64-0.32-1.28-0.533-1.92-0.213-0.32-0.427-0.747-0.533-1.067zM13.333 8.68c-0.213 0.32-0.32 0.747-0.533 1.067-0.213 0.533-0.32 1.173-0.533 1.92-0.213-0.107-0.32-0.107-0.427-0.213-0.747-0.427-1.173-0.853-1.28-1.173 0.853-0.64 1.813-1.28 2.773-1.6zM9.387 11.56c0.427 0.533 1.067 1.067 1.707 1.387 0.32 0.107 0.64 0.32 0.96 0.427-0.107 0.747-0.107 1.493-0.213 2.347h-4.053c0.213-1.6 0.747-2.987 1.6-4.16zM22.613 11.56c0.853 1.173 1.493 2.56 1.6 4.16h-4.16c0-0.853-0.107-1.6-0.213-2.347 0.32-0.107 0.64-0.213 0.96-0.427 0.747-0.32 1.387-0.853 1.813-1.387zM13.653 13.8c0.747 0.107 1.493 0.213 2.347 0.213s1.6-0.107 2.347-0.213c0.107 0.64 0.107 1.28 0.107 1.92h-4.907c0-0.747 0.107-1.28 0.107-1.92zM7.787 17.32h4.16c0 0.747 0.107 1.493 0.213 2.24-0.32 0.107-0.64 0.213-0.96 0.427-0.747 0.32-1.28 0.853-1.707 1.387-0.96-1.067-1.6-2.56-1.707-4.053zM13.547 17.32h4.907c0 0.64-0.107 1.28-0.107 1.813-0.747-0.107-1.493-0.213-2.347-0.213v0c-0.853 0-1.6 0.107-2.347 0.213 0-0.533-0.107-1.173-0.107-1.813zM20.053 17.32h4.16c-0.107 1.493-0.747 2.987-1.6 4.053-0.427-0.533-1.067-1.067-1.707-1.387-0.32-0.107-0.64-0.32-0.96-0.427 0.107-0.64 0.107-1.493 0.107-2.24zM16 20.627c0.747 0 1.387 0.107 2.027 0.213-0.107 0.64-0.32 1.28-0.533 1.813-0.32 0.747-0.64 1.387-0.853 1.707-0.32 0.32-0.533 0.427-0.64 0.427s-0.32-0.107-0.64-0.427c-0.32-0.32-0.64-0.96-0.853-1.707-0.213-0.533-0.32-1.173-0.533-1.813 0.64-0.213 1.28-0.213 2.027-0.213zM12.373 21.267c0.107 0.747 0.32 1.387 0.533 1.92 0.107 0.427 0.32 0.747 0.533 1.067-1.067-0.32-2.027-0.853-2.773-1.6 0.213-0.427 0.533-0.853 1.387-1.28 0 0 0.107 0 0.32-0.107zM19.627 21.267c0.107 0.107 0.32 0.107 0.427 0.213 0.747 0.427 1.173 0.853 1.387 1.28-0.853 0.747-1.813 1.28-2.773 1.6 0.213-0.32 0.32-0.747 0.533-1.067 0.107-0.64 0.32-1.387 0.427-2.027z"
		></path>
	</symbol>
</svg>
